/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Branch_Regenerate_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to regenerate response" |
*
* @param {Chat_Branch_Regenerate_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_branch_regenerate_failed = /** @type {((inputs?: Chat_Branch_Regenerate_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Branch_Regenerate_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neugenerierung fehlgeschlagen")
	return /** @type {LocalizedString} */ ("Failed to regenerate response")
});